// extracted by mini-css-extract-plugin
export default {"root":"booking_detail_item-module___root___a0b42199","container":"booking_detail_item-module___container___c5b45099"};